import React, { useCallback } from 'react';
import { Empty } from 'antd';
import Button from '../../../Buttons';
import WhaleSpot from '../../../../assets/img/emptySadWhale.svg';
import { Wrapper, Label, EmptyDescriptionBlock } from './styled';
export var NotFoundContent = function (_a) {
    var createNewOptionText = _a.createNewOptionText, onClick = _a.onClick, search = _a.search, _b = _a.addButtonLabel, addButtonLabel = _b === void 0 ? 'Добавить' : _b, _c = _a.emptyDescription, emptyDescription = _c === void 0 ? 'Ничего не найдено.' : _c, _d = _a.additionalDescription, additionalDescription = _d === void 0 ? '' : _d, _e = _a.showCreateNewOptionText, showCreateNewOptionText = _e === void 0 ? true : _e;
    var handleClick = useCallback(function () {
        onClick(search || '');
    }, [search, onClick]);
    return (React.createElement(Wrapper, null,
        React.createElement(Empty, { description: React.createElement(EmptyDescriptionBlock, null,
                React.createElement("span", null, emptyDescription),
                React.createElement("span", null, additionalDescription)), image: WhaleSpot }),
        showCreateNewOptionText && (React.createElement(Label, null,
            createNewOptionText || "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440",
            React.createElement("b", null,
                "\u00A0\u00AB",
                search,
                "\u00BB"),
            "?")),
        React.createElement(Button, { onClick: handleClick, type: 'primary' }, addButtonLabel)));
};
//# sourceMappingURL=NotFoundContent.js.map